import throttle from 'lodash.throttle';
import CRelatedStoryCarousel from '../components/CRelatedStoryCarousel';
import { scrollPageTo } from '../utils';
import BaseView from '../views/BaseView';

export default class Practice extends BaseView {
	constructor(container) {
		super(container);

		// DOM Elements
		this.cards = this.container.querySelectorAll('.practice-card');
		this.navButtons = this.container.querySelectorAll('.practice-cards-nav [data-target]');
		this.cardsContainer = this.container.querySelector('.practice-cards');
		this.progressBar = this.container.querySelector('[data-progress-bar]');
		this.indicator = this.progressBar.querySelector('.c-header-progress-bar__progress');

		// Misc
		this.breakpoint = window.matchMedia('(max-width:567px)');
	}

	init() {
		const groups = new Map([[CRelatedStoryCarousel, this.container.querySelectorAll('[data-c-related-story-carousel]')]]);

		super.createModules(groups);

		document.fonts.ready.then(() => {
			this.cards.forEach((card, index) => {
				// TODO: recalculate on resize?
				card.style.height = `${card.clientHeight}px`;

				// Make first card active
				if (index === 0) {
					this.activateCard(card);
				} else {
					card.classList.add('is-hidden');
				}
			});
		});

		// Scroll event listener
		this.boundCheckCards = throttle(this.checkCards.bind(this), 50);
		document.addEventListener('scroll', this.boundCheckCards);

		this.headerHeight = 0;
		if (this.breakpoint.matches !== true) {
			this.headerHeight = 53;
		} else {
			this.headerHeight = 63;
		}

		// Button navigation
		this.navButtons.forEach((button) => {
			button.addEventListener('click', (e) => {
				scrollPageTo(`[data-id="${button.dataset.target}"]`, 1000, -1 * this.headerHeight); // headerHeight offset
			});
		});
	}

	checkCards() {
		this.cards.forEach((card) => {
			const rect = card.getBoundingClientRect();
			const navButton = this.container.querySelector(`[data-target="${card.dataset.id}"]`);

			this.checkProgressBar();

			// Activate corresponding nav button
			if (navButton) {
				if (rect.top <= this.headerHeight + 1 && rect.bottom >= this.headerHeight + 1) {
					navButton.classList.add('is-active');
				} else {
					navButton.classList.remove('is-active');
				}
			}

			// If card is already shown, no need to do anything else except mark the corresponding nav button
			if (card.classList.contains('is-shown')) {
				navButton.classList.add('is-prev');
				return;
			}

			// Activate/de-activate card
			if (rect.bottom < this.headerHeight + 1) {
				this.deActivateCard(card);

				const next = card.nextElementSibling;

				if (next) {
					this.activateCard(next);
				}
			}
		});
	}

	checkProgressBar() {
		if (this.breakpoint.matches !== true) {
			return;
		}

		const rect = this.cardsContainer.getBoundingClientRect();

		// If scrolling where cards container is visible
		if (document.documentElement.clientHeight - rect.top >= 0 && rect.bottom - document.documentElement.clientHeight >= 0) {
			const diff = (rect.top - document.documentElement.clientHeight) * -1;
			const scrolled = (diff / this.cardsContainer.offsetHeight) * 100;

			this.progressBar.classList.add('is-active');
			this.indicator.style.width = `${scrolled}%`;
		}

		// Progress bar indicator should always be 100% if past cards container
		if (rect.bottom - document.documentElement.clientHeight <= 0) {
			this.indicator.style.width = `100%`;
		}

		// Only remove progress bar if above cards container
		if (document.documentElement.clientHeight - rect.top <= 0) {
			this.progressBar.classList.remove('is-active');
		}
	}

	activateCard(card) {
		card.classList.add('is-active');
		card.classList.remove('is-hidden');
	}

	deActivateCard(card) {
		card.classList.remove('is-active');
		card.classList.remove('is-hidden');
		card.classList.add('is-shown');
		card.style.height = 'auto';
	}

	destroy() {
		super.destroy();

		document.removeEventListener('scroll', this.boundCheckCards);
	}
}
